import ApiService from "@services/api.service";
import { Notify } from "quasar";

const PIF_ENDPOINT = 'etudiant_plan_individuel_formations';

// Champs en lecture seule à ne pas renvoyer à l'API
function cleanPayload(data) {
  const { '@context': _c, '@id': _i, '@type': _t, id: _id, ...rest } = data;
  return rest;
}

export const etudiantPif = {
  state: {
    pifs: [],
    pif: null,
  },
  mutations: {
    setPifs(state, pifs) {
      state.pifs = pifs;
    },
    setPif(state, pif) {
      state.pif = pif;
    },
    addPif(state, pif) {
      state.pifs.push(pif);
    },
    updatePif(state, pif) {
      const i = state.pifs.findIndex(p => p['@id'] === pif['@id']);
      if (i !== -1) state.pifs.splice(i, 1, pif);
    },
  },
  actions: {
    // Récupère les pif des étudiants actifs par session
    async fetchPifEtudiantSession(context) {
      try {
        const response = await ApiService.getRequest('get_pif_par_session');
        context.commit('setPifs', response.data);
      } catch (e) {
        console.error(e);
        Notify.create({ message: "Une erreur s'est produite", color: 'red' });
      }
    },

    // POST /etudiant_plan_individuel_formations
    async addEtudiantPif(context, data) {
      try {
        const response = await ApiService.postRequest(PIF_ENDPOINT, cleanPayload(data));
        context.commit('setPif', response.data);
        context.commit('addPif', response.data);
        Notify.create({ message: 'Suivi pédagogique enregistré', color: 'green' });
        return response.data;
      } catch (e) {
        console.error(e);
        Notify.create({ message: "Une erreur s'est produite lors de l'enregistrement", color: 'red' });
        throw e;
      }
    },

    // PATCH /etudiant_plan_individuel_formations/{id} (JSON)
    async editEtudiantPif(context, data) {
      try {
        const response = await ApiService.patchRequest(data['@id'], cleanPayload(data), {
          headers: { 'Content-Type': 'application/json' },
        });
        context.commit('setPif', response.data);
        context.commit('updatePif', response.data);
        Notify.create({ message: 'Suivi pédagogique modifié', color: 'green' });
        return response.data;
      } catch (e) {
        console.error(e);
        Notify.create({ message: "Une erreur s'est produite lors de la modification", color: 'red' });
        throw e;
      }
    },
  },
  getters: {
    getPifs(state) {
      return state.pifs;
    },
    getPif(state) {
      return state.pif;
    },
  },
};
